import { Box } from '@material-ui/core';
import React from 'react';

import { CustomPaper } from '@/components/shared/components/CustomPaper';
import { Icon } from '@/components/shared/components/Icon';
import { useCustomTheme } from '@/hooks/useCustomTheme';

import { Font } from '../../../../../../../shared/components/Font';
import { Text } from '../../../../../../../shared/components/Text';

export const NonAvailableElementWarning = ({
  iconName = 'badge',
  textId = 'ELEMENT_NOT_AVAILABLE',
  className = '',
  style = {},
}: {
  iconName?: string;
  textId?: string;
  className?: string;
  style?: React.CSSProperties;
}) => {
  const { palette } = useCustomTheme();

  return (
    <CustomPaper
      fill="grey.light"
      style={{
        padding: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '170px',
        height: '250px',
        ...style,
      }}
      className={className}
    >
      <Box display={'flex'} flexDirection={'column'} alignItems={'center'} color="textSecondary">
        <Icon style={{ verticalAlign: 'text-top', fontSize: '48px', color: palette.text.secondary }}>{iconName}</Icon>
        <Font variant="caption" color={'textSecondary'}>
          <Text tId={textId} />
        </Font>
      </Box>
    </CustomPaper>
  );
};
